import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Calendar, Clock } from "lucide-react";

export default function CompanyMeetings() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/meetings/").then(r => setItems(r.data || [])).catch(() => {}); }, []);
  return (
    <div>
      <h1 className="font-display text-2xl font-bold text-slate-900 mb-1">Incontri</h1>
      <p className="text-sm text-slate-600 mb-6">Le tue call programmate con il team CXOORA e i manager.</p>
      <div className="space-y-3">
        {items.map(m => (
          <div key={m.id} className="cxo-card p-5 flex items-center gap-4">
            <div className="w-11 h-11 rounded-lg bg-[#EAF0FF] flex items-center justify-center"><Calendar size={20} className="text-[#2D6BFF]" /></div>
            <div className="flex-1">
              <p className="font-semibold text-slate-900 capitalize">{m.type}</p>
              <p className="text-sm text-slate-600"><span className="cxo-tabular">{m.date}</span> alle <span className="cxo-tabular">{m.time}</span> · {m.duration_minutes} min</p>
              {m.notes && <p className="text-xs text-slate-500 mt-1">{m.notes}</p>}
            </div>
            <Badge className="bg-[#E9F8F1] text-[#1F9D6A] border-0">{m.status}</Badge>
            {m.meeting_link && <a href={m.meeting_link} target="_blank" rel="noreferrer" className="text-[#2D6BFF] text-sm font-semibold">Apri link</a>}
          </div>
        ))}
        {!items.length && <div className="cxo-card p-10 text-center text-slate-500">Nessun incontro programmato.</div>}
      </div>
    </div>
  );
}
